export const enum PlayStatus {
  INIT,
  PLAYING,
  WAITING,
}

export const enum DISCONNECT_CODE {
  MANUAL,
  RECONNECT,
}

export const enum PlayerEvents {
  ERROR = 'error',
  CONNECTED = 'connected',
  DESTROY = 'destroy',
  STATS = 'stats',
  WAITING = 'waiting',
  WAITING_STOP = 'waiting_stop',
  EMPTY = 'empty',
  RECONNECT = 'reconnect',
  PULL_START = 'pull_start',
  PULL_SUCCESS = 'pull_success',
}

export const enum ErrorCode {
  WEBRTC_FAIL = -1001,
  PULL_STREAM_FAIL = -1002,
  STREAM_DISCONNECT = -1003,
  DECODE_FAIL = -1004,
}
